export default __webpack_public_path__ + "static/media/side_rooms_dark.553cb41f.svg";